(function () {
    const DRAWER_ID = 'cherie-cart-drawer';
    const ITEMS_ID = 'cherie-drawer-items';

    let addBusy = false;

    // key -> { desiredQty, running, timerId }
    const lineState = new Map();

    function getCartType() {
        return document.documentElement.dataset.cartType || 'notification';
    }

    function getDrawer() {
        return document.getElementById(DRAWER_ID);
    }

    function openDrawer() {
        const d = getDrawer();
        if (!d) return;
        d.classList.remove('hidden');
        d.classList.add('is-open');
    }

    function closeDrawer() {
        const d = getDrawer();
        if (!d) return;
        d.classList.add('hidden');
        d.classList.remove('is-open');
    }

    function setItemBusy(key, isBusy) {
        const itemEl = document.querySelector(`[data-cart-item][data-key="${CSS.escape(key)}"]`);
        if (!itemEl) return;
        itemEl.classList.toggle('is-loading', !!isBusy);
    }

    async function fetchCart() {
        const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        return res.json();
    }

    function moneyFromCents(cents, currency) {
        const value = (cents / 100).toFixed(2);
        const cur = currency || window?.Shopify?.currency?.active || window?.Shopify?.currency?.shop;
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(value);
    }

    function escapeHtml(str) {
        return String(str ?? '')
            .replaceAll('&', '&amp;')
            .replaceAll('<', '&lt;')
            .replaceAll('>', '&gt;')
            .replaceAll('"', '&quot;')
            .replaceAll("'", '&#039;');
    }

    function renderDrawer(cart) {
        const root = document.getElementById(ITEMS_ID);
        if (!root) return;

        if (!cart.items || cart.items.length === 0) {
            root.innerHTML = `<p class="text-sm text-gray-500">Cart is empty</p>`;
            return;
        }

        root.innerHTML = cart.items
            .map((item) => {
                const compareHidden = item.original_price > item.final_price ? '' : 'hidden';
                const img = item.image ? `<img src="${escapeHtml(item.image)}" alt="" class="w-full h-full object-contain">` : '';
                const title = escapeHtml(item.product_title);
                const variant = item.variant_title && item.variant_title !== 'Default Title' ? escapeHtml(item.variant_title) : '';

                return `
            <div class="cherie-line border border-[#EAEAEA] p-3 flex gap-3" data-cart-item data-key="${escapeHtml(item.key)}">
              <a href="${escapeHtml(item.url)}" class="w-[64px] h-[64px] bg-[#F9F9F9] flex items-center justify-center shrink-0">
                ${img}
              </a>
  
              <div class="min-w-0 flex flex-col gap-1 w-full">
                <div class="flex justify-between gap-2">
                  <div class="min-w-0">
                    <a href="${escapeHtml(item.url)}" class="font-playfair text-[13px] leading-tight block truncate">${title}</a>
                    ${variant ? `<p class="text-[11px] text-gray-500 mt-0.5 truncate">${variant}</p>` : ''}
                  </div>
  
                  <button type="button"
                    class="text-[12px] text-gray-400 hover:text-black shrink-0"
                    data-cherie-cart-remove data-key="${escapeHtml(item.key)}" aria-label="Remove">✕</button>
                </div>
  
                <div class="flex items-baseline gap-2 font-playfair">
                  <span class="text-[13px] text-black">${moneyFromCents(item.final_price, cart.currency)}</span>
                  <span class="text-[12px] text-[#FF5C1B] line-through ${compareHidden}">
                    ${moneyFromCents(item.original_price, cart.currency)}
                  </span>
                </div>
  
                <div class="flex items-center justify-between gap-2 mt-1">
                  <div class="relative flex items-center border border-black">
                    <button type="button" class="px-2 py-1 text-xs" data-cherie-qty-dec data-key="${escapeHtml(item.key)}">-</button>
                    <input class="w-10 text-center text-xs py-1" type="number" min="1" value="${item.quantity}"
                      data-cherie-qty-input data-key="${escapeHtml(item.key)}">
                    <button type="button" class="px-2 py-1 text-xs" data-cherie-qty-inc data-key="${escapeHtml(item.key)}">+</button>
  
                    <div class="cherie-line-loader pointer-events-none absolute inset-0 hidden items-center justify-center bg-white/70">
                      <span class="cherie-spinner" aria-hidden="true"></span>
                    </div>
                  </div>
  
                  <p class="text-[12px] text-gray-400 whitespace-nowrap">
                    Total: <span class="text-black">${moneyFromCents(item.final_line_price, cart.currency)}</span>
                  </p>
                </div>
              </div>
            </div>
          `;
            })
            .join('');

        // повернути лоадери для ліній які зараз в апдейті
        for (const [key, st] of lineState.entries()) {
            if (st?.running) setItemBusy(key, true);
        }
    }

    async function addToCartAjax(form) {
        const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form),
        });

        if (!res.ok) {
            let msg = 'Add to cart error';
            try {
                const j = await res.json();
                msg = j?.description || j?.message || msg;
            } catch (e) {}
            throw new Error(msg);
        }

        document.dispatchEvent(new CustomEvent('cart:updated'));
    }

    // ✅ Головне: відправляємо change.js тільки після паузи (debounce)
    function queueChangeDebounced(key, desiredQty, delayMs = 250) {
        const qty = Math.max(1, parseInt(desiredQty || '1', 10));

        const st = lineState.get(key) || { desiredQty: qty, running: false, timerId: null };
        st.desiredQty = qty;

        if (st.timerId) clearTimeout(st.timerId);

        // показуємо лоадер одразу, щоб було відчуття “прийняло кліки”
        setItemBusy(key, true);

        st.timerId = setTimeout(async () => {
            // якщо в цей момент вже йде запит — просто дочекаємось його завершення,
            // і наступний debounce ще раз запланує (бо desiredQty оновлюється)
            if (st.running) return;

            st.running = true;
            lineState.set(key, st);

            try {
                const res = await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                    body: JSON.stringify({ id: key, quantity: st.desiredQty }),
                });

                if (!res.ok) throw new Error('Cart update failed');

                const cart = await res.json();
                renderDrawer(cart);
                document.dispatchEvent(new CustomEvent('cart:updated'));
            } catch (err) {
                console.error(err);
                alert(err.message || 'Error');
                const cart = await fetchCart();
                renderDrawer(cart);
            } finally {
                st.running = false;
                st.timerId = null;
                lineState.set(key, st);
                setItemBusy(key, false);

                // якщо поки ми апдейтили user ще наклацав — desiredQty змінився і timerId вже виставлений новий
            }
        }, delayMs);

        lineState.set(key, st);
    }

    // optimistic UI: інкрементимо інпут одразу
    function bumpQtyFromUI(key, delta) {
        const line = document.querySelector(`[data-cart-item][data-key="${CSS.escape(key)}"]`);
        if (!line) return;

        const input = line.querySelector('[data-cherie-qty-input]');
        if (!input) return;

        const current = Math.max(1, parseInt(input.value || '1', 10));
        const next = Math.max(1, current + delta);

        input.value = String(next);
        queueChangeDebounced(key, next, 250);
    }

    // 1) Add to cart (drawer/page/notification)
    document.addEventListener(
        'click',
        async (e) => {
            const btn = e.target.closest('.add-to-cart');
            if (!btn) return;
            if (btn.classList.contains('no-drawer')) return;

            const form = btn.closest('form');
            if (!form) return;

            const cartType = getCartType();

            // якщо не наш режим — нічого не чіпаємо
            if (!['drawer', 'page', 'notification'].includes(cartType)) return;

            // page = редірект, НЕ перехоплюємо
            if (cartType === 'page') {
                return; // даємо формі відпрацювати нормально (редірект на /cart)
            }

            // drawer/notification = AJAX, перехоплюємо клік
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            if (addBusy) return;
            addBusy = true;

            try {
                await addToCartAjax(form);

                if (cartType === 'drawer') {
                    const cart = await fetchCart();
                    renderDrawer(cart);
                    openDrawer();
                } else if (cartType === 'notification') {
                    showCartToast('Товар додано до кошика');
                }
            } catch (err) {
                console.error(err);
                alert(err.message || 'Error');
            } finally {
                addBusy = false;
            }
        },
        true,
    );

    // 2) Drawer controls
    document.addEventListener('click', (e) => {
        const inc = e.target.closest('[data-cherie-qty-inc]');
        const dec = e.target.closest('[data-cherie-qty-dec]');
        const rem = e.target.closest('[data-cherie-cart-remove]');

        if (inc) {
            bumpQtyFromUI(inc.dataset.key, +1);
            return;
        }
        if (dec) {
            bumpQtyFromUI(dec.dataset.key, -1);
            return;
        }
        if (rem) {
            const key = rem.dataset.key;
            // remove: qty=0 (окремо, без min=1)
            const st = lineState.get(key) || { desiredQty: 0, running: false, timerId: null };
            if (st.timerId) clearTimeout(st.timerId);
            setItemBusy(key, true);

            (async () => {
                try {
                    const res = await fetch('/cart/change.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                        body: JSON.stringify({ id: key, quantity: 0 }),
                    });
                    if (!res.ok) throw new Error('Cart update failed');
                    const cart = await res.json();
                    renderDrawer(cart);
                    document.dispatchEvent(new CustomEvent('cart:updated'));
                } catch (err) {
                    console.error(err);
                    alert(err.message || 'Error');
                    const cart = await fetchCart();
                    renderDrawer(cart);
                } finally {
                    setItemBusy(key, false);
                    st.running = false;
                    st.timerId = null;
                    lineState.set(key, st);
                }
            })();
        }
    });

    document.addEventListener('change', (e) => {
        const input = e.target.closest('[data-cherie-qty-input]');
        if (!input) return;
        const key = input.dataset.key;
        const qty = Math.max(1, parseInt(input.value || '1', 10));
        input.value = String(qty);
        queueChangeDebounced(key, qty, 250);
    });

    // close
    document.addEventListener('click', (e) => {
        if (e.target.closest('[data-cherie-cart-close]')) closeDrawer();
    });

    // refresh when drawer open
    document.addEventListener('cart:updated', async () => {
        const drawer = getDrawer();
        if (!drawer || drawer.classList.contains('hidden')) return;
        const cart = await fetchCart();
        renderDrawer(cart);
    });

    function showCartToast(text = 'Товар додано до кошика') {
        const toast = document.getElementById('cherie-cart-toast');
        if (!toast) return;

        toast.textContent = text;
        toast.classList.remove('opacity-0');
        toast.classList.add('opacity-100');

        clearTimeout(toast._timer);
        toast._timer = setTimeout(() => {
            toast.classList.remove('opacity-100');
            toast.classList.add('opacity-0');
        }, 2500);
    }
})();
